import { render, staticRenderFns } from "./TraceNewBatchBatchDetails.template.vue?vue&type=template&id=0f42bedf&scoped=true&"
var script = {}
import style0 from "./TraceNewBatchBatchDetails.template.vue?vue&type=style&index=0&id=0f42bedf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f42bedf",
  null
  
)

export default component.exports